import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-board-search',
  templateUrl: './board-search.component.html',
  styleUrls: ['./board-search.component.scss']
})
export class BoardSearchComponent implements OnInit {
  @Output() search: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onSearch(input) {
    this.search.emit(input.value);
  }

}
